import { TimelineSection } from '../../_models/timeline-models/section-listing.model';

/** The timeline section types that hold a learner report a client may see only once it is approved. */
const APPROVAL_GATED_SECTIONS = ['classic-ilp', 'progress-report'];

/** The report status id of an approved ILP or progress report (tblBaseline / tblProgressReport StatusId 3). */
const STATUS_APPROVED = 3;

/**
 * The sections a client user's timeline shows: an ILP or progress report only once it is approved, every
 * other section as before. The API already leaves the others out for a client user; this keeps the screen
 * in step with it.
 */
export function clientVisibleSections<T extends TimelineSection>(sections: T[]): T[] {
  return (sections || []).filter(section =>
    !APPROVAL_GATED_SECTIONS.includes(section.sectionType) || (section as any).statusId === STATUS_APPROVED);
}
